import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';
import Utils from '../../utils/Utils';
import SparkleIcon from '../icons/SparkleIcon';

const badgeVariants = cva(
  "inline-flex items-center gap-2 rounded-lg border-[0.67px] border-solid border-[#E5E7EB] bg-[#ffffffcc] px-[12px] py-[6.67px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.1),0px_1px_3px_rgba(0,0,0,0.1)] text-[12px] leading-4 font-normal text-[#364153] font-['Inter',Helvetica] backdrop-blur-[2px] whitespace-nowrap",
  {
    variants: {
      variant: {
        default: '',
        secondary: '',
        destructive: '',
        outline: '',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  showIcon?: boolean;
}

function Badge({ className, variant, showIcon = true, children, ...props }: BadgeProps) {
  return (
    <div className={Utils.cn(badgeVariants({ variant }), className)} {...props}>
      {showIcon && <SparkleIcon className="w-[10px] h-[10px] text-[#6840c6] flex-shrink-0" />}
      {children}
    </div>
  );
}

export { Badge, badgeVariants };
